var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.811 0a1.6 1.6 0 0 0-1.6 1.6v.21A6.4 6.4 0 0 0 2.411 8v1.916a9.5 9.5 0 0 1-.748 3.684H15.96a9.5 9.5 0 0 1-.749-3.684V8a6.4 6.4 0 0 0-4.8-6.19V1.6a1.6 1.6 0 0 0-1.6-1.6m-8 15.2a.8.8 0 1 0 0 1.6h5.741a2.4 2.4 0 0 0-.14.8 2.4 2.4 0 1 0 4.66-.8h5.74a.8.8 0 1 0 0-1.6z"
  })));
};
export default SvgBell;